// write your code here
/* global jstag */
/* eslint no-undef: "error" */

import axios from 'axios';

const apiKey = process.env.KEY;
const lyticsEndpoint = process.env.URL;

axios.defaults.headers.post['x-api-key'] = apiKey;

function getBasicPayload(eventType) {
  let lyticsID = jstag.ckieGet('seerid')
  if (!lyticsID) lyticsID = -1;
  // this is checking on the website if the var providerId exist
  // eslint-disable-next-line no-undef
  const checkProviderId = () => {
    if(typeof(providerId) !== 'undefined' && providerId !== null) {
      return providerId;
    } else {
      return '';
    }
  }

  const checkDataStream = () => {
    if(typeof(dataStream) !== 'undefined' && dataStream !== null) {
      return dataStream;
    } else {
      return '';
    }
  }

  const payload = {
    id: lyticsID,
    name: eventType,
    idType: 'LyticsId',
    dataStream: checkDataStream(),
    createdDate: new Date().toUTCString(),
    domain: window.location.hostname,
    providerId: checkProviderId(),
  }

  return payload
}

window.addEventListener('load', (e) => {
  e.preventDefault();
  const params = (new URL(document.location)).searchParams;

  if (params) {
    let subId = '';
    if (params.get('s1')) subId = params.get('s1');
    else if (params.get('subid')) subId = params.get('subid');

    let productInterest = '';
    const productInterestEl = document.getElementById('product_interest');
    if (typeof (productInterestEl) !== 'undefined' && productInterestEl != null) productInterest = productInterestEl.value;

    const payload = {
      ...getBasicPayload('LyticsOnLoad'),
      cpid: params.get('cpid'),
      subId,
      lastPageVisited: window.location.pathname,
      productInterest,
    }

    axios.post(lyticsEndpoint, payload).catch((error) => {
      console.log(error);
    });
  } else console.log('No load data was posted to lytics');

  return true;
})

window.addEventListener('submit', (e) => {
  e.preventDefault();

  const formData = new FormData(e.target);
  if (formData && (formData.get('email') || formData.get('email_address') || formData.get('QuoteEmail')) && formData.get('first_name')) {
    const payload = getBasicPayload('LyticsFormSubmit');
    payload.formSubmit = 'Form Submitted';
    formData.forEach((value, key) => {
      payload[key] = value;
    })
    axios.post(lyticsEndpoint, payload).catch((error) => {
      console.log(error);
    })
  } else console.log('No form data was posted to lytics');

  return true;
})
